import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { host } from "config";
import { useEffect, useState } from "react";
import isEmail from "validator/lib/isEmail";

export interface ConfirmResumeOTCDialogProps {
  open: boolean;
  guid: string;
  onClose: () => void;
  setFormData: (formData: { [key: string]: any }) => void;
}

function ConfirmResumeOTCDialog(props: ConfirmResumeOTCDialogProps) {
  const [otc, setOTC] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const { open, guid, onClose, setFormData } = props;

  useEffect(() => {
    setIsLoading(true);
    fetch(`${host}/api/Reporting/FormSubmissions/generatePartialSubmissionOTC`, {
      method: "POST",
      body: JSON.stringify({ guid: guid }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          response.text().then((text) => {
            throw new Error(text);
          });
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error: ", error);
        alert(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleClose = () => {
    onClose();
  };
  const handleSubmit = () => {
    fetch(`${host}/api/Reporting/FormSubmissions/verifyPartialSubmissionOTC`, {
      method: "POST",
      body: JSON.stringify({ guid: guid, code: otc }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          response.text().then((text) => {
            throw new Error(text);
          });
        }
        response.json().then(async (json: any) => {
          setIsLoading(false);
          setFormData(json.data);
          handleClose();
          alert("Form loaded successfully!");
        });
      })
      .catch((error: any) => {
        console.error("Error:", error);
        alert(
          "There was an error while saving the form. Please try again later and contact IT if the problem persists."
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>Load Saved Partial Submission</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          A one time code has been sent to your email and will be valid for the next 15 minutes. Please enter the code
          below.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          variant="outlined"
          placeholder="One Time Code"
          value={otc}
          onChange={(e) => setOTC(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button onClick={handleClose}>Close</Button>
        <Button onClick={handleSubmit} variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmResumeOTCDialog;
